/*
 * Ensure telehealth feedback survey copy is defined here and used as an eum where
 * needed. This enables consistent record keeping between what users see and what
 * we save to the DB.
 * */

export enum QNamesToQText {
  howWasYourVisit = "How was your visit with your practitioner?",
  whyDidYouSelect = "Why did you select that rating?",
  whatWouldHaveMadeBetter = "What would have made this visit better for you?",
}

export enum QTypes {
  singleChoice = "singleChoice",
  multipleChoiceWithOtherText = "multipleChoiceWithOtherText",
  openText = "openText",
}

export const whyDidYouSelectOptions = {
  didntLearn: "Didn't learn anything new",
  tooShort: "Visit was too short",
  notPersonalized: "Wasn't personalized enough",
  other: "Other",
};
